// extracted by mini-css-extract-plugin
export default {"continueButton":"ExtensionUpsell_continueButton__54r-R"};